<template>
  <div>
    <div v-if="user" id="database">
      <nav class="navbar sticky-top navbar-light bg-light">
        <div class="input-group my-2">
          <!-- Search UI Group -->
          <div v-if="!showGenes" class="row mr-0">
            <div class="selection-group-btn">
              <button
                type="button"
                class="ml-3 btn btn-info dropdown-toggle"
                data-flip="false"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <font-awesome-icon icon="hand-pointer" />
                <span class="caret"></span>
              </button>
              <div class="dropdown-menu">
                <a
                  class="dropdown-item"
                  href="#"
                  id="project"
                  v-on:click.prevent="requestTypeChange('project')"
                >
                  Project
                  <span v-if="selectedType === 'project'">&#x2713;</span>
                </a>
                <a
                  class="dropdown-item"
                  href="#"
                  id="cart"
                  v-on:click.prevent="requestTypeChange('cart')"
                >
                  Cart
                  <span v-if="selectedType === 'cart'">&#x2713;</span>
                </a>
                <a
                  class="dropdown-item"
                  href="#"
                  id="package"
                  v-on:click.prevent="requestTypeChange('package')"
                >
                  Package
                  <span v-if="selectedType === 'package'">&#x2713;</span>
                </a>
                <a
                  class="dropdown-item"
                  href="#"
                  id="strain"
                  v-on:click.prevent="requestTypeChange('strain')"
                >
                  Strain
                  <span v-if="selectedType === 'strain'">&#x2713;</span>
                </a>
                <a
                  class="dropdown-item"
                  href="#"
                  id="library_sequence"
                  v-on:click.prevent="requestTypeChange('library_sequence')"
                >
                  Sequence
                  <span v-if="selectedType === 'library_sequence'"
                    >&#x2713;</span
                  >
                </a>
              </div>
              <!-- .dropdown-menu -->
            </div>
            <!-- .selection-group-btn -->

            <div
              v-if="
                selectedType === 'project' ||
                  selectedType === 'library_sequence'
              "
              class="add-btn ml-1"
            >
              <button
                type="button"
                class="btn btn-info"
                data-toggle="modal"
                data-target="#addNewItem"
                v-on:click="prepAddItem(item)"
                data-backdrop="static"
                data-keyboard="false"
              >
                <font-awesome-icon icon="plus" />
              </button>
            </div>
          </div>
          <input
            id="searchTerm"
            placeholder="Search"
            type="text"
            class="form-control ml-1"
            aria-label="Search"
            v-model="searchTerm"
          />

          <div class="search-group-btn">
            <button
              type="button"
              class="ml-1 btn btn-info dropdown-toggle"
              data-flip="false"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <font-awesome-icon icon="search" />
              <span class="small mt-2 ml-1">{{
                filterKey | searchFilter
              }}</span>
              <span class="caret"></span>
            </button>

            <div class="dropdown-menu dropdown-menu-right">
              <a
                class="dropdown-item"
                href="#"
                id="merge"
                v-on:click.prevent="requestKeyChange('merge')"
              >
                Merge
                <span v-if="filterKey === 'merge'">&#x2713;</span>
              </a>

              <a
                class="dropdown-item"
                href="#"
                id="olab_id"
                v-on:click.prevent="requestKeyChange('olab_id')"
              >
                OLAB ID
                <span v-if="filterKey === 'olab_id'">&#x2713;</span>
              </a>

              <a
                class="dropdown-item"
                href="#"
                id="name"
                v-on:click.prevent="requestKeyChange('name')"
              >
                Name
                <span v-if="filterKey === 'name'">&#x2713;</span>
              </a>

              <a
                v-if="showGenes === false"
                class="dropdown-item"
                href="#"
                id="creator"
                v-on:click.prevent="requestKeyChange('creator')"
              >
                Creator
                <span v-if="filterKey === 'creator'">&#x2713;</span>
              </a>

              <a
                v-if="showGenes === true"
                class="dropdown-item"
                href="#"
                id="b_number"
                v-on:click.prevent="requestKeyChange('b_number')"
              >
                B Number
                <span v-if="filterKey === 'b_number'">&#x2713;</span>
              </a>

              <a
                v-if="showGenes === true"
                class="dropdown-item"
                href="#"
                id="locus_tag"
                v-on:click.prevent="requestKeyChange('locus_tag')"
              >
                Locus Tag
                <span v-if="filterKey === 'locus_tag'">&#x2713;</span>
              </a>

              <a
                v-if="showGenes === true"
                class="dropdown-item"
                href="#"
                id="old_locus_tag"
                v-on:click.prevent="requestKeyChange('old_locus_tag')"
              >
                Old Locus Tag
                <span v-if="filterKey === 'old_locus_tag'">&#x2713;</span>
              </a>

              <a
                v-if="selectedType === 'library_sequence' || showGenes === true"
                class="dropdown-item"
                href="#"
                id="seq"
                v-on:click.prevent="requestKeyChange('seq')"
              >
                Sequence
                <span v-if="filterKey === 'seq'">&#x2713;</span>
              </a>
            </div>
            <!-- .dropdown-menu -->
          </div>
          <!-- search-group-btn -->
        </div>
        <!-- input-group my-2 -->

        <div class="navbar-brand text-truncate">
          <!-- Placeholder for user profile-->
          <button
            type="button"
            class="btn btn-outline-danger ml-1"
            data-toggle="modal"
            data-target="#userProfile"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="id-badge" />
          </button>
          <button
            type="button"
            class="btn btn-outline-success ml-1"
            data-toggle="modal"
            data-target="#infoProfile"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="info" />
          </button>
          <span class="h4 text-success text-capitalize ml-2"
            >{{ selectedTypeName }} Database System</span
          >
        </div>
        <!-- navbar-brand text-truncate -->

        <div v-if="showGenes" class="navbar-text ml-auto d-flex">
          <button
            type="button"
            class="btn btn-info ml-1"
            v-on:click="doSwitchFromGene()"
          >
            Exit Genes <font-awesome-icon icon="sign-out-alt" />
          </button>
        </div>
        <!-- .navbar-text ml-auto d-flex -->

        <div v-if="error" class="col-12 alert alert-danger px-3">
          {{ error }}
        </div>
      </nav>
      <!-- sticky-top -->

      <!-- userProfile -->
      <OlabUserProfile :user="user" />

      <!-- infoProfile -->
      <OlabInfoProfile :user="user" :selectedTypeName="selectedTypeName" />

      <div class="modal fade" id="addNewItem">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Add:
                <span class="text-dark text-truncate">
                  {{ selectedTypeName }}
                </span>
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <!-- .modal-header -->
            <div class="modal-body">
              <form>
                <fieldset class="form-group">
                  <!-- <legend>{{ selectedType }} Info</legend> -->
                  <div class="form-group">
                    <label class="form-control-label font-italic">
                      <span>Name:</span>
                      <span class="small text-danger">*</span>
                    </label>
                    <input
                      class="form-control"
                      v-bind:class="item.getValidState(item.name)"
                      type="text"
                      v-model="item.name"
                    />
                    <!-- <div class="invalid-feedback">{{ invalidFB.name }}</div> -->
                  </div>
                  <div
                    v-if="selectedType === 'library_sequence'"
                    class="form-group"
                  >
                    <label class="form-control-label font-italic">
                      <span>Sequence Origin:</span>
                      <span class="small text-danger">*</span>
                    </label>
                    <select
                      class="form-control"
                      v-bind:class="item.getValidState(item.seq_origin)"
                      v-model="item.seq_origin"
                    >
                      <option disabled value="null">Please select one</option>
                      <option
                        v-for="seq in dbInfo.db_configs.seq_origins"
                        :key="seq.olab_id"
                        >{{ seq.strain }} &nbsp; - &nbsp; {{ seq.name }}</option
                      >
                    </select>
                    <!-- <div class="invalid-feedback">{{ invalidFB.seq_origin }}</div> -->
                    <!-- <span>selected = {{item.seq_origin}}</span> -->
                  </div>
                  <div v-if="selectedType === 'project'" class="form-group">
                    <label class="form-control-label font-italic">
                      <span>Start Date:</span>
                      <span class="small text-danger">*</span>
                    </label>
                    <input
                      class="form-control"
                      v-bind:class="item.getValidState(item.start_date)"
                      type="date"
                      v-model="item.start_date"
                    />
                    <!-- <div class="invalid-feedback">{{ invalidFB.startDate }}</div> -->
                  </div>
                  <div v-if="selectedType === 'project'" class="form-group">
                    <label class="form-control-label font-italic"
                      >End Date:</label
                    >
                    <input
                      class="form-control"
                      type="date"
                      v-model="item.end_date"
                    />
                  </div>
                  <div v-if="selectedType === 'strain'" class="form-group">
                    <label class="form-control-label font-italic"
                      >Project ID:</label
                    >
                    <select class="form-control" v-model="item.project_id">
                      <option disabled value="null">Please select one</option>
                      <option v-for="pj in projects" :key="pj.olab_id"
                        >{{ pj.olab_id }}&nbsp; - &nbsp;{{ pj.name }}</option
                      >
                    </select>
                    <!-- <span>selected = {{item.project_id}}</span> -->
                  </div>
                  <div v-if="selectedType === 'strain'" class="form-group">
                    <label class="form-control-label font-italic">
                      <span>Parent ID:</span>
                      <span class="small text-danger">*</span>
                    </label>
                    <select
                      class="form-control"
                      v-bind:class="item.getValidState(item.parent_id)"
                      v-model="item.parent_id"
                    >
                      <option disabled value="null">Please select one</option>
                      <option v-for="sss in strains" :key="sss.olab_id"
                        >{{ sss.olab_id }}&nbsp; - &nbsp;{{ sss.name }}</option
                      >
                    </select>
                    <!-- <div class="invalid-feedback">{{ invalidFB.parentID }}</div> -->
                    <!-- <span>selected = {{item.parent_id}}</span> -->
                  </div>
                  <div v-if="selectedType === 'strain'" class="form-group">
                    <label class="form-control-label font-italic"
                      >Mutations:</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      v-model="item.mutations"
                    />
                  </div>
                  <div v-if="selectedType === 'strain'" class="form-group">
                    <label class="form-control-label font-italic">
                      <span>Antibiotic Resistance:</span>
                      <span class="small text-danger">*</span>
                    </label>
                    <input
                      class="form-control"
                      v-bind:class="
                        item.getValidState(item.antibiotic_resistance)
                      "
                      type="text"
                      v-model="item.antibiotic_resistance"
                    />
                    <!-- <div class="invalid-feedback">
                      {{ invalidFB.antibioticResistance }}
                    </div> -->
                  </div>
                  <div v-if="selectedType === 'strain'" class="form-group">
                    <label class="form-control-label font-italic"
                      >WGS Confirmed:</label
                    >
                    <div class="form-check form-check-inline mx-1">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="true"
                        v-model="item.wgs_confirmed"
                      />
                      <label class="form-check-label">true</label>
                    </div>
                    <div class="form-check form-check-inline mx-1">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="false"
                        v-model="item.wgs_confirmed"
                      />
                      <label class="form-check-label">false</label>
                    </div>
                  </div>
                  <div
                    v-if="selectedType === 'library_sequence'"
                    class="form-group"
                  >
                    <label class="form-control-label font-italic">
                      <span>Library ID:</span>
                      <span class="small text-danger">*</span>
                    </label>
                    <select
                      class="form-control"
                      v-bind:class="item.getValidState(item.library_id)"
                      v-model="item.library_id"
                    >
                      <option disabled value="null">Please select one</option>
                      <option v-for="lll in libraries" :key="lll.olab_id"
                        >{{ lll.olab_id }}&nbsp; - &nbsp;{{ lll.name }}</option
                      >
                    </select>
                    <!-- <div class="invalid-feedback">{{ invalidFB.libraryID }}</div> -->
                    <!-- <span>selected = {{item.library_id}}</span> -->
                  </div>

                  <div
                    v-if="
                      selectedType === 'strain' ||
                        selectedType === 'library_sequence'
                    "
                    class="form-group"
                  >
                    <label class="form-control-label font-italic"
                      >Source:</label
                    >
                    <select class="form-control" v-model="item.source">
                      <option disabled value="null">Please select one</option>
                      <option value="inhouse">inhouse</option>
                      <option value="public">public</option>
                    </select>
                    <!-- <span>selected = {{item.source}}</span> -->
                  </div>
                  <div v-if="selectedType === 'strain'" class="form-group">
                    <label class="form-control-label font-italic">
                      <span>Storage:</span>
                      <span class="small text-danger">*</span>
                    </label>
                    <input
                      class="form-control"
                      v-bind:class="item.getValidState(item.storage)"
                      type="text"
                      v-model="item.storage"
                    />
                    <!-- <div class="invalid-feedback">{{ invalidFB.storage }}</div> -->
                  </div>
                  <div
                    v-if="selectedType === 'library_sequence'"
                    class="form-group"
                  >
                    <label for="seq" class="form-control-label font-italic">
                      <span>Sequence:</span>
                      <span class="small text-danger">*</span>
                    </label>
                    <textarea
                      class="form-control"
                      v-bind:class="item.getSeqValidState()"
                      id="seq"
                      v-model="item.seq"
                    ></textarea>
                    <div class="invalid-feedback">
                      {{ item.invalidSeqFeedback }}
                    </div>
                    <small
                      class="form-text text-muted font-italic"
                      id="seq_help"
                      >Note: Sequence cannot be modified once it is
                      created.</small
                    >
                  </div>
                  <div
                    v-if="selectedType === 'library_sequence'"
                    class="form-group"
                  >
                    <span class="font-italic">Length:</span>
                    <span class="h5 text-dark">{{ itemSeqLen }}</span>
                  </div>
                  <div class="form-group">
                    <label class="form-control-label font-italic"
                      >Creator:</label
                    >
                    <span class="ml-1">{{ item.creator }}</span>
                  </div>
                  <div class="form-group">
                    <label class="form-control-label font-italic"
                      >Description:</label
                    >
                    <textarea
                      class="form-control"
                      v-model="item.desc"
                    ></textarea>
                  </div>
                </fieldset>
                <!-- .form-group -->
              </form>
            </div>
            <!-- .modal-body -->

            <div class="modal-footer">
              <button
                type="button"
                v-bind:disabled="itemAddIsDisabled == true"
                class="btn btn-primary"
                v-on:click="handleAddItem(item)"
              >
                Add
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
            <!-- .modal-footer -->
          </div>
          <!-- .modal-content -->
        </div>
        <!-- .modal-dialog .modal-lg-->
      </div>
      <!-- .modal fade addNewItem -->

      <div v-if="showGenes">
        <DatabaseGeneList
          v-if="user"
          :user="user"
          :genes="selected.genes"
          :error="error"
          :selectedType="selectedType"
        />
      </div>
      <div v-else>
        <DatabaseItemList
          v-if="user"
          :user="user"
          :dbInfo="dbInfo"
          :projects="projects"
          :microbes="microbes"
          :strains="strains"
          :libraries="libraries"
          :error="error"
          :selectedItems="selected.items"
          :selectedType="selectedType"
          :item="item"
          @doSaveItem="doSaveItem"
          @doSwitchToGene="doSwitchToGene"
        />
      </div>
      <div class="my-5">
        <nav aria-label="Page navigation">
          <ul class="pagination justify-content-center">
            <li class="page-item">
              <button
                type="button"
                v-bind:disabled="selected.prevIsDisabled == true"
                class="btn btn-primary"
                v-on:click="handlePrev()"
              >
                &lt;
              </button>
            </li>
            <li class="mx-3">{{ selected.pageNumber }}</li>
            <li class="page-item">
              <button
                type="button"
                v-bind:disabled="selected.nextIsDisabled == true"
                class="btn btn-primary"
                v-on:click="handleNext()"
              >
                &gt;
              </button>
            </li>
          </ul>
        </nav>
        <div
          v-if="
            searchTerm &&
              searchTerm.length < 5 &&
              filterKey == 'merge' &&
              selected.nextRecRef
          "
          class="text-center"
        >
          <small
            >Merge search browsing may miss finding if search string is too
            short.</small
          >
        </div>
      </div>
    </div>
    <div v-else class="mt-5">
      <div class="text-secondary text-center">
        <div class="h2">
          Inactivity Time Out
        </div>
        <router-link
          class="btn btn-outline-primary mt-2"
          to="/login"
          v-if="!user"
          >Log in</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import DatabaseItemList from "@/components/DatabaseItemList";
import DatabaseGeneList from "@/components/DatabaseGeneList";
import OlabUserProfile from "@/components/OlabUserProfile";
import OlabInfoProfile from "@/components/OlabInfoProfile";
// import _ from "lodash";
import { OlabItem } from "../olab/olabitem.js";
// import { OlabGene } from "../olab/olabgene.js";
// import { OlabCart } from "../olab/olabcart.js";
import { OlabUtils } from "../olab/olabutils.js";
import { OlabSearch } from "../olab/olabsearch.js";
import db from "../olab/db.js";
import $ from "jquery";

export default {
  name: "database",
  data: function() {
    return {
      title: "Database",
      searchTerm: "",
      filterKey: "merge",
      filterDir: "asc",
      selectedType: "project",
      lastSelectedType: null,
      selectedTypeName: "Project",
      selectedItem: null,
      item: new OlabItem(),
      invalidFB: OlabItem.getInvalidFeedbacks(),
      showGenes: false,
      geneCollectionStr: null,
      selected: {
        genes: null,
        items: null,
        collectionRef: null,
        collectionOrderBy: "olab_id",
        pageNumber: 1,
        nextRecRef: null,
        nextIsDisabled: true,
        // This is an array of prev page refs
        prevRecRefArr: [],
        prevIsDisabled: true
      }
    };
  },
  components: {
    FontAwesomeIcon,
    DatabaseItemList,
    DatabaseGeneList,
    OlabUserProfile,
    OlabInfoProfile
  },
  props: [
    "user",
    "dbInfo",
    "projects",
    "microbes",
    "strains",
    "libraries",
    "error"
  ],
  mounted: function() {
    OlabUtils.infoLog("Database mounted ...");
    this.selected.items = this.projects;
  },
  computed: {
    itemAddIsDisabled: function() {
      switch (this.selectedType) {
        case "project":
          return (
            !this.item.isValid(this.item.name) ||
            !this.item.isValid(this.item.creator) ||
            !this.item.isValid(this.item.start_date)
          );
        // break;
        case "strain":
          return (
            !this.item.isValid(this.item.name) ||
            !this.item.isValid(this.item.parent_id) ||
            !this.item.isValid(this.item.antibiotic_resistance) ||
            !this.item.isValid(this.item.storage) ||
            !this.item.isValid(this.item.creator)
          );
        // break;
        case "library_sequence":
          return (
            !this.item.isValid(this.item.name) ||
            !this.item.isValid(this.item.library_id) ||
            !this.item.isValid(this.item.seq_origin) ||
            !this.item.processSeq() ||
            !this.item.isValid(this.item.creator)
          );
        // break;
      }
      return false;
    },
    itemSeqLen: function() {
      return this.item.seq ? this.item.seq.length : "--";
    }
  },
  filters: {
    searchFilter: function(value) {
      switch (value) {
        case "merge":
          return "Merge";
        case "olab_id":
          return "OLAB ID";
        case "name":
          return "Name";
        case "creator":
          return "Creator";
        case "b_number":
          return "B Number";
        case "locus_tag":
          return "Locus";
        case "old_locus_tag":
          return "Old Locus";
        case "seq":
          return "Sequence";
      }
    }
  },
  methods: {
    // doComputedItems: function(items) {
    //   return _.orderBy(
    //     items,
    //     function(item) {
    //       return item[this.filterKey] == null
    //         ? null
    //         : item[this.filterKey].toLowerCase();
    //     }.bind(this),
    //     this.filterDir
    //   );
    // },
    handlePrev: function() {
      let sType = this.selectedType;
      if (this.showGenes) {
        sType = "genome";
      }
      OlabUtils.infoLog("handlePrev ... sType = " + sType);
      OlabSearch.doPrev(sType, this.selected);
    },
    handleNext: function() {
      let sType = this.selectedType;
      if (this.showGenes) {
        sType = "genome";
      }
      OlabUtils.infoLog("handleNext ... sType = " + sType);
      OlabSearch.doNext(sType, this.selected);
    },
    computeCount: function(c, seq) {
      let cnt = 0;
      for (let i = 0; i < seq.length; i++) {
        if (seq[i].toUpperCase() == c) {
          cnt++;
        }
      }
      return cnt;
    },
    requestTypeChange: function(value) {
      this.selectedType = value;
      OlabUtils.infoLog("requestTypeChange " + this.selectedType);
      if (this.selectedType !== this.lastSelectedType) {
        // Reset searchTerm when type changed
        this.searchTerm = "";

        OlabUtils.infoLog("Watch - selectedType = " + this.selectedType);

        switch (this.selectedType) {
          case "project":
            this.selectedTypeName = "Project";
            this.searchTerm = "";
            this.doSearchTerm(this.searchTerm, this.selectedType);
            break;
          case "cart":
            this.selectedTypeName = "Cart";
            this.searchTerm = "";
            this.doSearchTerm(this.searchTerm, this.selectedType);
            break;
          case "package":
            this.selectedTypeName = "Package";
            this.searchTerm = "";
            this.doSearchTerm(this.searchTerm, this.selectedType);
            break;
          case "strain":
            this.selectedTypeName = "Strain";
            this.searchTerm = "";
            this.doSearchTerm(this.searchTerm, this.selectedType);
            break;
          case "library_sequence":
            this.selectedTypeName = "Sequence";
            this.searchTerm = "";
            this.doSearchTerm(this.searchTerm, this.selectedType);
            break;
        }
        this.lastSelectedType = this.selectedType;
      }
    },
    requestKeyChange: function(value) {
      this.filterKey = value;
      this.doSearchTerm(this.searchTerm, this.selectedType);
    },
    doSaveItem: function({ item, items }) {
      // TODO: This is temporarily hack to update old data
      if (this.selectedType == "library_sequence") {
        // Compute seq's gene_stats
        const numA = this.computeCount("A", item.seq);
        const numC = this.computeCount("C", item.seq);
        const numG = this.computeCount("G", item.seq);
        const numT = this.computeCount("T", item.seq);
        let shortSeq = item.seq.substring(0, 25);
        if (item.seq.length > 25) {
          shortSeq = shortSeq + "...";
        }
        item.gene_stats = {
          len: item.seq.length,
          num_a: numA,
          num_c: numC,
          num_g: numG,
          num_t: numT,
          short_seq: shortSeq
        };
      }

      this.$emit("saveItem", {
        item: item,
        items: items
      });
    },
    doSwitchToGene: function(item) {
      OlabUtils.infoLog("doSwitchToGene: item: " + item.olab_id);

      let microbeID = item.olab_id.substr(0, item.olab_id.indexOf("-"));
      this.geneCollectionStr =
        "microbes/" + microbeID + "/olab_items/" + item.olab_id + "/olab_genes";
      OlabUtils.infoLog(
        "doSwitchToGene: geneCollectionStr: " + this.geneCollectionStr
      );
      this.showGenes = true;
      this.doSearchTerm(this.searchTerm, "genome");
    },
    doSwitchFromGene: function() {
      OlabUtils.infoLog("doSwitchFromGene ...");
      this.searchTerm = "";
      this.showGenes = false;
      this.doSearchTerm(this.searchTerm, this.selectedType);
    },
    prepAddItem: function(item) {
      OlabUtils.infoLog("prepAddItem");
      item.initItem();
      // initialize creator with user's email
      item.creator = this.user.email;
    },
    handleAddItem: function(item) {
      if (this.selectedType == "strain") {
        let mID = item.parent_id.substr(0, item.parent_id.indexOf("-"));
        this.microbes.forEach(mb => {
          if (mb.olab_id == mID) {
            item.microbe_type = mb.microbe_type;
          }
        });
        OlabUtils.infoLog(
          "item.microbe_type = " + item.microbe_type + ", mID = " + mID
        );
      }

      OlabUtils.infoLog(
        "Add item = " + item + ", selectedType = " + this.selectedType
      );

      if (this.selectedType == "library_sequence") {
        // Compute seq's gene_stats
        const numA = this.computeCount("A", item.seq);
        const numC = this.computeCount("C", item.seq);
        const numG = this.computeCount("G", item.seq);
        const numT = this.computeCount("T", item.seq);
        let shortSeq = item.seq.substring(0, 25);
        if (item.seq.length > 25) {
          shortSeq = shortSeq + "...";
        }
        item.gene_stats = {
          len: item.seq.length,
          num_a: numA,
          num_c: numC,
          num_g: numG,
          num_t: numT,
          short_seq: shortSeq
        };

        // Do duplicate check if by doing a quick gene_stats compare
        db.collectionGroup("olab_items")
          .where("olab_type", "==", "library_sequence")
          .where("gene_stats.num_a", "==", item.gene_stats.num_a)
          .where("gene_stats.num_c", "==", item.gene_stats.num_c)
          .where("gene_stats.num_g", "==", item.gene_stats.num_g)
          .where("gene_stats.num_t", "==", item.gene_stats.num_t)
          .where("gene_stats.short_seq", "==", item.gene_stats.short_seq)
          .get()
          .then(snapshot => {
            const snapArr = [];
            let found = false;
            snapshot.forEach(doc => {
              OlabUtils.infoLog(doc.id + " => " + doc.data());
              snapArr.push(doc.data());
            });
            if (snapArr.length > 0) {
              // Do local duplicate check of return sequences using exact seq
              OlabUtils.infoLog("** snapArr.length = " + snapArr.length);
              for (let i = 0; i < snapArr.length; i++) {
                OlabUtils.infoLog(
                  "ele = " + i + ", seq.length = " + snapArr[i].seq.length
                );
                if (
                  snapArr[i].seq.length == item.seq.length &&
                  snapArr[i].seq == item.seq
                ) {
                  found = true;
                  break;
                }
              }
            }
            if (found) {
              item.setSeqExisted(true);
            } else {
              item.setSeqExisted(false);

              this.$emit("addItem", {
                item: item,
                type: this.selectedType,
                items: this.selected.items
              });
              $("#addNewItem").modal("hide");
            }
          })
          .catch(error => {
            OlabUtils.infoLog("** Error reading document: " + error);
            this.error = error;
          });
      } else {
        this.$emit("addItem", {
          item: item,
          type: this.selectedType,
          items: this.selected.items
        });
        $("#addNewItem").modal("hide");
      }
    },
    doSearchTerm: function(sTerm, sType) {
      if (this.showGenes) {
        sType = "genome";
      }
      // OlabUtils.infoLog("doSearchTerm - sTerm = " + sTerm + ", sType = " + sType + ", filterKey = " + this.filterKey + ", geneCollectionStr = " + this.geneCollectionStr);
      OlabSearch.doSearchTerm(
        sTerm,
        sType,
        this.filterKey,
        this.geneCollectionStr,
        this.selected
      );
    }
  },
  watch: {
    searchTerm: function() {
      OlabUtils.infoLog("Watch - searchTerm = " + this.searchTerm);
      this.doSearchTerm(this.searchTerm, this.selectedType);
    },
    projects: function() {
      this.selected.items = this.projects;
    }
  }
};
</script>
